import React from "react";
import { useSelector } from "react-redux";

import { useLocalStorage } from "../../../hooks";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";

import email_img from "../../../assets/Email.svg";
import individual_profile from "../../../assets/individual_profile.svg";
import institute_img from "../../../assets/Institute.svg";
import marker_img from "../../../assets/location.svg";
import web_img from "../../../assets/Website.svg";
import { TwInputGroup, TwLocationInput, TwPhoneInputGroup, TwTextarea } from "../../../components/tailwind";
import { classNames } from "../../../helpers";
import { useTranslation } from "react-i18next";

export default function BusinessProfileForm(props) {
  const { t, i18n } = useTranslation();
  const { showContactDetails = false } = props;
  const dashboardReduxState = useSelector(dashboardState);
  const [userToken] = useLocalStorage("userToken", "");

  const [businessTypeOpts, setBusinessTypeOpts] = React.useState([]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    props.form.setValues({
      ...props.form.values,
      [name]: value,
    });
  };
  
  return (
    <div className={"w-full md:w-auto flex flex-col gap-4"}>
      {false && showContactDetails === false && (<div className="md:max-w-lg">
        <label className={classNames("block text-sm/6 font-medium text-black/[0.6]",)}>Organization Profile Type</label>
        <div className="mt-2 space-y-6 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
          {[
            { id: "individual", title: "Individual" },
            { id: "business", title: "Business" },
          ].map((notificationMethod) => (
            <div key={notificationMethod.id} className="flex items-center">
              <input
                defaultChecked={notificationMethod.id === props.form.values.businessProfileType}
                id={notificationMethod.id}
                name="businessProfileType"
                type="radio"
                className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:!border-primary checked:!bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
                onChange={(event) => {
                  props.form.setFieldValue("businessProfileType", notificationMethod.id)
                }}
              />
              <label htmlFor={notificationMethod.id} className="ml-3 block text-sm/6 font-medium text-gray-900">
                {notificationMethod.title}
              </label>
            </div>
          ))}
        </div>
      </div>)}
      {showContactDetails === false && (<TwInputGroup
        label={t("inputFieldsTitle.orgName")}
        placeholder={t(props.form.values.businessProfileType === 'individual' ? "inputFieldsTitle.hostName" : "inputFieldsTitle.orgName")}
        name={"businessName"}
        leftIcon={(<img className={""} src={props.form.values.businessProfileType === 'individual' ? individual_profile : institute_img} alt={""} />)}
        value={props.form.values?.businessName}
        onChange={handleInputChange}
        errors={props.form.errors}
      />)}
      {showContactDetails === false && (<TwTextarea
        label={t("inputFieldsTitle.aboutOrg")}
        name={"about"}
        row={3}
        value={props.form.values?.about}
        onChange={handleInputChange}
        errors={props.form.errors}
      />)}
      <TwLocationInput
        label={t("inputFieldsTitle.contactAddress")}
        name={"address"}
        leftIcon={(<img className={""} src={marker_img} alt={""} />)}
        defaultLocationSelect={props.form.values?.address}
        onLocationSelect={(data) => {
          props.form.setFieldValue("locationObj", data)
          props.form.setFieldValue("address", data)
          // setAddress(data);
        }}
        errors={props.form.errors}
      />
      <TwPhoneInputGroup
        label={t("inputFieldsTitle.contactNumber")}
        placeholder={t("inputFieldsTitle.phoneNumber")}
        name={"workNumber"}
        value={props.form.values.workNumber}
        onChange={(phone, country, e) => {
          const numberWithoutDialCode = phone.split("");
          for (let i = 0; i < country.dialCode.length; i++) {
            numberWithoutDialCode.shift();
          }
          let dialCode = country.dialCode;
          if (
            country.format.includes("+") &&
            !country.dialCode.includes("+")
          ) {
            dialCode = "+".concat(country.dialCode);
          }
          props.form.setFieldValue("countryName", country.countryCode);
          props.form.setFieldValue("countryCode", dialCode);
          props.form.setFieldValue("phone", numberWithoutDialCode.join(""));
          props.form.setFieldValue("formattedPhoneNumber", e.target.value);
          props.form.setFieldValue("workNumber", e.target.value);
        }}
        errors={props.form.errors}
      />
      <TwInputGroup
        label={t("inputFieldsTitle.contactEmail")}
        placeholder={t("inputFieldsTitle.contactEmail")}
        name={"workEmail"}
        leftIcon={(<img className={""} src={email_img} alt={""} />)}
        value={props.form.values?.workEmail}
        onChange={handleInputChange}
        errors={props.form.errors}
      />
      {showContactDetails === false && (<TwInputGroup
        label={t("inputFieldsTitle.contactWebsiteOpt")}
        placeholder={t("inputFieldsTitle.websiteOptPlaceholder")}
        name={"workWebsite"}
        leftIcon={(<img className={""} src={web_img} alt={""} />)}
        value={props.form.values?.workWebsite}
        onChange={handleInputChange}
        errors={props.form.errors}
      />)}
    </div>
  );
}
